/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
import { useContext, useState } from 'react';
import { Formik, Form } from 'formik';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { Modal } from 'react-bootstrap';
import TextBox from '../TextBox/textBox.component';
import Select from '../Select/select.component';
import PriorAuthorizationService from '../../services/PriorAuthorization/priorauthorization.service';
import { PriorAuthorizationDomainDetails, UploadedFilesInfo } from '../../interfaces/PriorAuthorizationDomain';
import { IFormSchemaWithData } from '../../interfaces/IFormSchemaWithData';
import useFieldChangeNotifier from '../hooks/useFieldChangeNotifier';
import { PriorAuthorizationDomainContext, usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';
import Procedure from '../Procedure/procedure.component';
import InputTags from '../InputTags/InputTags.component';
import './formbuilder.component.css';
import DocumentUpload from '../DocumentUpload/documentUpload.component';
import RequestingProvider from '../RequestingProvider/requestingprovider.component';

interface IFormBuilderProps {
  formSchemaWithData: IFormSchemaWithData[],
  uploadedDocs?: UploadedFilesInfo[],
}
export const FormBuilder = ({ formSchemaWithData, uploadedDocs }: IFormBuilderProps) => {
  const navigate = useNavigate();
  const handleChange = useFieldChangeNotifier();
  const handleClose = (): void => setShow(false);
  const [show, setShow] = useState<boolean>(false);

  const { priorAuthorizationDomain } = useContext(PriorAuthorizationDomainContext);

  const { isServiceProviderPhoneValid, requestingProviderValidationStatuses, fieldValidationStatuses, procedureValidationStatuses, sameDiagnosticAddedStatuses, filesUploadedValidationStatus } = usePADomainModel();

  const allRequestingProviderValid = Object.values(requestingProviderValidationStatuses).every((status) => status === true);

  const allFieldsValid = Object.values(fieldValidationStatuses).every((status) => status === true);

  const allProceduresValid = Object.values(procedureValidationStatuses).every((status) => status === true);

  const allDiagosticCodesValid = Object.values(sameDiagnosticAddedStatuses).every((status) => status === true);

  const allFilesUploadedValid = Object.values(filesUploadedValidationStatus).every((status) => status === true);

  const getFormElement = (elementName: any, elementId: any, elementSchema: any, hidden: boolean) => {
    const props = {
      name: elementName,
      label: elementSchema.label,
      options: elementSchema.options,
      onChange: handleChange,
      id: elementId,
      readonly: elementSchema.readonly,
      required: elementSchema.required,
      requiredmessage: elementSchema.requiredmessage,
      format: elementSchema.format,
      convert: elementSchema.convert,
      hidden,
    };

    if (elementSchema.type === 'text') {
      return <TextBox {...props} />;
    }

    if (elementSchema.type === 'select') {
      return <Select {...props} />;
    }
  };

  const initialValues = formSchemaWithData.map((formItem, formIndex) => {
    const formInitialValues = formItem.priorAuthDomainObjDetails || {};
    const formObject: Record<string, any> = {};
    Object.keys(formItem.formSchema).forEach((field) => {
      const key = `form${formIndex}${field}`;
      formObject[key] = formInitialValues[field as keyof PriorAuthorizationDomainDetails] || formItem.formSchema[field].value || '';
    });
    return formObject;
  });

  const handleSubmit = (values: any) => {
    PriorAuthorizationService.submitPriorAuhtorization(priorAuthorizationDomain).then((result) => {
      navigate('/precertificationSummary', { state: { domainObject: priorAuthorizationDomain } });
    }, (respsone: string) => {
      if (respsone.length > 0) {
        alert(respsone);
      }
    });
  };

  const handleSave = () => {
    if (!allFilesUploadedValid) {
      setShow(true);
    } else {
      handleContinue();
    }
  };

  const handleContinue = () => {
    setShow(false);
    PriorAuthorizationService.savePriorAuthorization(priorAuthorizationDomain).then(() => {
      alert('Request saved successfully');
    }, () => {
      alert('Error saving request');
    });
  };
  function isServiceProceduresValid(index: number) {
    // iterate thru procedureValidationStatuses with key:index(servicedetails)-x(procedure) ex. 3-1
    //  if one value is false, then return false.
    for (const key of Object.keys(procedureValidationStatuses)) {
      if (key.startsWith(`${index}-`) && !procedureValidationStatuses[key]) {
        return false;
      }
    }
    return true;
  }

  return (
    <div>
      <Formik
        initialValues={{
          forms: initialValues,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ setFieldValue }) => (
          <Form>
            {formSchemaWithData.map((formItem, index) => (
              <div key={index} className="list-group-item" hidden={!formItem.priorAuthDomainObjDetails.cignaManaged}>
                <h5>
                  {formItem.priorAuthDomainObjDetails.authorizationType}
                  -
                  {formItem.priorAuthDomainObjDetails.typeOfServiceDescription}
                </h5>
                {Object.keys(formItem.formSchema).map((field, fieldIndex) => (
                  <div key={fieldIndex}>
                    {getFormElement(`forms[${index}].${`form${index}${field}`}`, `form${index}${field}`, formItem.formSchema[field as keyof typeof formItem.formSchema], !formItem.priorAuthDomainObjDetails.cignaManaged)}
                  </div>
                ))}
                <div className="mb-4" />
                <div className="form-group" tabIndex={1}>
                  <div id="myTabContent" className="tab-content mt-1 ">
                    <div className="tab-pane fade show active">
                      <label className="fw-bold mb-0" htmlFor="codes">Procedures</label>
                      <Procedure
                        items={formItem.priorAuthDomainObjDetails.proceduresDetails}
                        serviceDetailIndex={index}
                        admissionStartDate={formItem.priorAuthDomainObjDetails.admissionStartDate}
                        setProcedureValues={(procedureValues) => setFieldValue(`forms.${index}.procedure`, procedureValues)}
                        serviceType={formItem.priorAuthDomainObjDetails.typeOfServiceDescription}
                      />
                      <div hidden={isServiceProceduresValid(index)} className="procedureErrorMessage" data-testid={`diagnosisErrorMessage-${index}`}>Please complete procedure details</div>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <InputTags items={formItem.priorAuthDomainObjDetails.additionalDiagnosis} diagnosisCode={formItem.priorAuthDomainObjDetails.diagnosisCode} index={index} setInputTagsValues={(inputTagsValues) => setFieldValue(`forms.${index}.additionalDiagnosis`, inputTagsValues)} labelText="Additional Diagnosis Codes (optional)" />
                </div>
                <div>
                  <div className="mb-0  col-auto p-0">
                    <RequestingProvider
                      cignaManaged={formItem.priorAuthDomainObjDetails.cignaManaged}
                      requestingprovider={formItem.priorAuthDomainObjDetails.requestingProvider}
                      setRequestingProviderValues={(requestingProviderValues) => {
                        setFieldValue(`forms.${index}.requestingProvider`, requestingProviderValues);
                      }}
                      index={index}
                    />
                  </div>
                </div>
                <DocumentUpload index={index} items="" serviceRequestId={formItem.priorAuthDomainObjDetails.serviceRequestId} uploadedDocs={uploadedDocs ? _.filter(uploadedDocs, { serviceRequestId: formItem.priorAuthDomainObjDetails.serviceRequestId }) : []} />
              </div>
            ))}

            <div className="mt-5 col-12 d-none d-lg-inline-flex justify-content-start p-0 ">
              <div className="col d-inline-flex justify-content-end pr-0 pl-0">
                <button type="button" data-testid="testSave" onClick={handleSave} className="saveButton btn btn-secondary rounded-pill px-4">Save</button>
                <button type="submit" data-testid="testSubmit" className="submitButton btn btn-primary rounded-pill px-4" disabled={!isServiceProviderPhoneValid || !allRequestingProviderValid || !allFieldsValid || !allProceduresValid || !allDiagosticCodesValid || !allFilesUploadedValid}>Submit</button>
              </div>
            </div>

            <Modal show={show}>
              <div className="modal fade show exitFormBase" data-testid="exitModal" id="exitModal" tabIndex={-1} role="dialog" data-backdrop="static" aria-modal="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header shadow-sm">
                      <h5
                        id="title-of-modal"
                        data-testid="modalTitle"
                        className="modal-title"
                      >
                        Document Upload Warning
                      </h5>
                      <button
                        type="button"
                        className="close"
                        id="closeIcon"
                        data-dismiss="modal"
                        onClick={handleClose}
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body" data-testid="modalBody">
                      <p>Are you sure you want to continue with save? Any documentation that has not been properly uploaded will not be saved.</p>
                    </div>
                    <div id="modal-footer-id" className="modal-footer border-0">
                      <button id="cancel-button" data-testid="cancelButton" type="button" data-dismiss="modal" aria-label="Close" onClick={handleClose} className="btn btn-sm btn-secondary mr-2">Cancel</button>
                      <button
                        id="primary-exit-button"
                        data-testid="saveAndExitButton"
                        type="button"
                        onClick={handleContinue}
                        data-dismiss="modal"
                        aria-label="Save and Exit"
                        className="btn btn-sm btn-primary mr-2"
                      >
                        Continue Without Upload
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </Form>
        )}
      </Formik>
    </div>
  );
};
